import { render, staticRenderFns } from "./ModalResumoQhRecesso.vue?vue&type=template&id=3830720a"
import script from "./ModalResumoQhRecesso.vue?vue&type=script&lang=js"
export * from "./ModalResumoQhRecesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports